import {kGamesImages} from "../../../constants/images";
import Lottie from 'react-lottie-player'
import animationData from '../../../animations/games/fireworksAnimation.json'

export default function GamesResultImage() {
    // Used in GameRecordResultContent to display
    // image with background firework animation

    // BUILD
    return (
        <div className={"relative w-[120px] min-w-[120px] h-[96px] flex justify-center items-center"}>
            <Lottie
                loop
                animationData={animationData}
                play
                style={{ width: 172, height: 144, transform: 'translateY(-24px)' }} />
            <img className={"absolute z-10 object-contain h-[96px]"}
                 alt={"Record"}
                 src={kGamesImages.recordImage} />
        </div>
    );
}